import React, { useState } from "react";
import RenderDesktopCalculator from "./RenderDesktopCalculator";
import Calculator from "./../../Sections/CalculatorsSection/Calculator";
import imgSrc from "../../Assets/img/misc/commingSoonCalculator.png";
import Close from "@material-ui/icons/Close";
import "./main.css";
function Intermediate(props) {
  const [showModal, setShowModal] = useState(true);
  return (
    <div className="blogdiv overflow-auto">
      <div className="d-flex withfilter">
        <Close
          onClick={() => {
            props.onCloseCalculator();
          }}
        />
        <h2>
          {props.serviceTitle} <span>{props.serviceId}/12</span>
        </h2>
      </div>
      {props.calculators.length === 0 ? (
        <div className="calculator-not-available">
          <img src={imgSrc} alt="Calculator not enabled" />
          <p className="text-left">
            The calculator will be enabled shortly. In the meantime if you have
            any questions about life insurance then please reach out over phone
            or email
          </p>
        </div>
      ) : (
        <div className="row align-items-center justify-content-center">
          {props.calculators.map((calc, index) => (
            <RenderDesktopCalculator
              calculator={calc}
              key={`${calc.name}_${index}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default Intermediate;
